document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const qty = params.get('quantity');
  if (!qty) return;

  const input = document.querySelector('quantity-selector-component input[name="quantity"]');
  if (input) {
    input.value = qty;
    input.focus();
    input.blur();
  }
});